import { useContextSelector } from 'use-context-selector';
import type { UseIsEntitySuspended } from '../../../hooks/useIsEntitySuspended';
import {
  PageFunctionControllerContext,
  type PageFunctionControllerContextType,
} from './PageFunctionControllerContext';

const usePageFunctionControllerSelector = <T>(
  selector: (context: PageFunctionControllerContextType) => T,
): T => {
  return useContextSelector(PageFunctionControllerContext, (context) => {
    if (!context) throw new Error('PageFunctionControllerContext is undefined');
    return selector(context);
  });
};

export const usePFCGlobalStateStore = () => {
  return usePageFunctionControllerSelector((ctx) => ctx.useGlobalStateStore)();
};

export const usePFCDependencyGraphProvider = () => {
  return usePageFunctionControllerSelector((ctx) => ctx.useDependencyGraphProvider)();
};

export const usePFCNonReactiveComputeContext = ({ entityId }: { entityId: string }) => {
  return usePageFunctionControllerSelector((ctx) => ctx.useNonReactiveComputeContext)({
    mode: 'mutable',
    entityId,
  });
};

export const usePFCInterfaceStore = () => {
  return usePageFunctionControllerSelector((ctx) => ctx.useInterfaceStore)();
};

export const usePFCUseTriggerAutomaticDataSources = ({
  dataSourceIds,
}: {
  dataSourceIds?: string[];
}) => {
  return usePageFunctionControllerSelector((ctx) => ctx.useTriggerAutomaticDataSources)({
    dataSourceIds,
  });
};

export const usePFCUseIsEntitySuspended: UseIsEntitySuspended = ({ dataSourceIds, context }) => {
  return usePageFunctionControllerSelector((ctx) => ctx.useIsEntitySuspended)({
    dataSourceIds,
    context,
  });
};
